import clsx from "clsx";
import { calculateRate, ITestResult } from "./statics";
import { Check, Warning, X } from "@phosphor-icons/react";

export default function TestResultSummary({
  data,
}: {
  data: null | ITestResult[];
}) {
  const rate = calculateRate(data);

  return (
    <div className="bg-surface-1 h-full flex flex-col font-outfit pt-2 pr-2 pl-1">
      <div className="spm-title flex justify-between">
        <div>TEST SONUÇLARI</div>
        <div className="text-myGreen">
          {rate !== null ? Math.ceil(rate) : rate}%
        </div>
      </div>
      <div className="text-base flex-1 overflow-auto text-white/80">
        {data?.length === 0 && (
          <div className="flex border-myRose/20 border rounded-lg items-center mt-2 bg-myRose/15 p-2 pr-4 gap-2">
            <Warning size={20} className="text-myRose" />
            <div className="flex-1">
              Kodunda bir yazım ya da mantık hatası var.
            </div>
          </div>
        )}
        {data?.map((s) => (
          <div
            key={s.name}
            className="flex items-center gap-4 py-3 pl-3 pr-5 border-b border-white/15 last:border-b-0"
          >
            <div
              className={clsx(
                "",
                s.status === "pass" ? "text-myGreen" : "text-myRed"
              )}
            >
              {s.status === "fail" ? <X size={20} /> : <Check size={20} />}
            </div>
            <div>{s.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
